<template>
    <v-dialog
      v-model="dialog"
      @keydown.esc="close"
      :content-class="!loading ? 'white-background pdf-content' : ''"
    >
    <div class="PDF" >
      <PDFViewer
        v-if="!loading"
        :url="url"
        :pdf_data="pdf_data"
        :is_mobile="is_mobile"
        @closePdf="close"
      ></PDFViewer>
      <div class="qmkey-pdf-no-content" v-if="!loading">
        <v-alert
          dense
          prominent
          :type="alert_type"
          :value="alert"
          class="qmkey-pdf-alert"
        >
          <div>
            {{ error_message }}
          </div>
        </v-alert>
      </div>
      <v-overlay
          absolute
          :value="!!loading"
          color="white"
          class="pdf-loading-overlay"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            class="circle"
          ></v-progress-circular>
        </v-overlay>
    </div>
    </v-dialog>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import QReport from '@/api/QReportsItem'
import PDFViewer from '@/components/pdf_viewer/new_components/PDFViewer.vue'
import QUnitAPI from '@/api/QUnit';

export default {
  name: 'app',

  components: {
    PDFViewer,
  },

  props: {
    unit: {required: true},
    template: {defalut: null},
  },

  mounted: function(){
    //this.showPDF()
  },
  computed: {
    ...mapGetters(['centro_id']),
    ...mapState(['is_mobile',]),
  },

  data() {
    return {
      dialog: false,
      url: null,
      pdf_data: null,
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      loading: true,
      error_message: 'No se pudo cargar el PDF',
      alert: false,
      alert_type: "error",
    };
  },

  methods: {
    open() {
      this.loading = true;
      this.dialog = true;
      this.showPDF();
    },
    close() {
      this.pdf_data = null; //Clear memory
      this.dialog = false;
      this.$emit('close');
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },

    async showPDF(){
      if (  this.centro_id      &&
            this.unit.qunit_id  &&
            this.unit.attribute &&
            this.unit.value     &&
            //this.unit.version   && DO not check it's non necesary
            this.unit.title ) {

        let response = null;
        try {
          response = await QUnitAPI.getQUnitFile(
            this.centro_id,
            this.unit.qunit_id,
            this.unit.attribute,
            this.unit.value,
            this.unit.version,
            this.unit.title,
            this.unit.pmethod || "rendered_pdf_header" // render_method shold be pdf always
          );
        } catch (err) {
          this.loading = false;
          this.alert = true;
          console.error(err);
          return;
        }

        this.pdf_data = response.data;
        this.loading = false;
        this.dialog = true

      } else {
        this.loading = false;
        this.alert = true;
        console.warn('Missing some path parameters');
      }
    },
  },

}
</script>


<style lang="scss">
  @import "@/sass/pdf.scss";
  .qmkey-pdf-no-content {
    
    display: flex;
    max-width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 25%;
  }
  .qmkey-pdf-alert {
    max-width: 50%;
  }
  .white-background {
    background-color: white;
    max-height: 100% !important;
    width: 100%;
    height: 100%;
    margin: 0px !important;
    bottom: 0;
    top: auto;
  }
</style>
